export default __webpack_public_path__ + "static/bcorp-logo-white-0e2af416800e7252267a6bc1e79fc633.svg";